<script lang="ts">
    import { Heading } from "flowbite-svelte";
    import TypeIt from "typeit";
    import { onMount } from "svelte";
    import ColoredModal from "../colored/ColoredModal.svelte";
    import ColoredButton from "../colored/ColoredButton.svelte";

    let {isOpen = $bindable(), close}: { isOpen: boolean, close: () => void } = $props();

    onMount(() => {

        new TypeIt("#typing", {
            speed: 100,
            deleteSpeed: 400,
            startDelay: 200,
            lifeLike: true,
            afterComplete: async (instance: TypeIt) => {
                instance.destroy(true);
            },
        }).type('Made with <span class="text-pink-400 font-black">LOVE</span> by Carter')
            .pause(1700)
            .move(-10)
            .delete(4)
            .pause(900)
            .type('<span class="text-amber-300 font-black">JOY</span>')
            .pause(2000)
            .delete(3)
            .pause(300)
            .type('<span class="text-blue-300 font-black">CARTER</span>')
            .pause(2000)
            .delete(6)
            .pause(300)
            .type('<span class="font-fancy italic">tears</span>')
            .pause(2000)
            .delete(11)
            .empty({instant: true})
            .type(`<span class="text-blue-300">Made by Carter</span>`, {instant: true})
            .go();
    });

</script>

<div class="z-51 absolute top-0 left-0 w-full h-full {!isOpen ? 'hidden' : ''}">
    <ColoredModal autoclose bind:open={isOpen} onclose={close} size="lg">
        <div class="text-center text-">

            <Heading id="typing"
                     class="mb-5 text-5xl font-normal text-gray-500 black:text-gray-200 frappe:text-ctp-subtext0"></Heading>

            <ColoredButton class="mt-5 me-2">Okay</ColoredButton>
        </div>
    </ColoredModal>
</div>